// src/processors/resource/resource-file-handler.ts - Resource File Operations
import { XConVitePluginOptions } from '../../types';
import { pathUtils } from '../../utils/path-utils';
import { fsUtils } from '../../utils/fs-utils';
import {Logger} from "../../utils/logger";

/**
 * Handles xchtml file loading and resource file operations
 */
export class ResourceFileHandler {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {}

    /**
     * Load xchtml file content
     */
    loadXChtmlFile(
        xchtmlPath: string,
        id: string,
        addWatchFile: (file: string) => void
    ): string | null {
        const tsFileDir = pathUtils.dirname(id);
        const fullTemplatePath = pathUtils.resolve(tsFileDir, xchtmlPath);

        // Add to watch files for hot reload
        if (this.options.watchFiles && fsUtils.isNodeEnvironment()) {
            addWatchFile(fullTemplatePath);
        }

        if (!fsUtils.existsSync(fullTemplatePath)) {
            return null;
        }

        try {
            const content = fsUtils.readFileSync(fullTemplatePath, 'utf8');
            return content;
        } catch (error) {
            this.logger.error(`Failed to read xchtml file ${fullTemplatePath}:`, error);
            return null;
        }
    }
}